export default __webpack_public_path__ + "static/media/braze.8c2ddb66.svg";